import { useTrackingOp } from "../../../contexts/TrackingOpContext";
import WeatherChart from "../../WeatherChart";

export default function WeatherSection() {
    const [weather] = useTrackingOp(state => state.weather);

    return <div className="w-full flex justify-center">
        <div className="px-[8%] w-full">
            <WeatherChart loading={weather?.loading} weather={weather?.data} minInterval={10800000} />
        </div>
    </div>
}
